import {Injectable, OnInit} from '@angular/core';
import {Product} from 'src/app/interfaces/common/product';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FilterData} from "../../interfaces/core/filter-data";
import {environment} from "../../../environments/environment";

const API_URL = environment.apiBaseLink + '/api/product/';

@Injectable({
  providedIn: 'root'
})
export class ProductService implements OnInit {

  // // GET ALL PRODUCTS AT DB
  // private allProducts = ALL_PRODUCTS.slice(0, 19);

  constructor(
    private httpClient: HttpClient
  ) {
  }

  ngOnInit(): void {

  }

  /**
   * getAllProducts
   * getProductById
   */


  getAllProducts(filterData: FilterData, searchQuery?: string) {
    // Ensure `type` is always included for UI cards (ProductCard shows type name)
    const finalFilterData: FilterData = {
      ...filterData,
      select: {
        ...(filterData?.select ?? {}),
        type: 1,
      },
    };
    let params = new HttpParams();
    if (searchQuery) {
      params = params.append('q', searchQuery);
    }
    return this.httpClient.post<{
      data: Product[],
      count: number,
      success: boolean
    }>(API_URL + 'get-all', finalFilterData, {params});
  }


  getAllProductsCount(data: any) {
    return this.httpClient.post<{ success: boolean }>(API_URL + 'product-count', data);
  }

  getAllProductsCounts() {
    return this.httpClient.get<{ data: any, message: string, success: boolean }>(API_URL + 'get-all-product-count');
  }

  getProductById(id: string, select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.get<{ data: Product, message: string, success: boolean }>(API_URL + id, {params});
  }

  getProductBySlug(slug: string, select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.get<{
      data: Product,
      message: string,
      success: boolean
    }>(API_URL + 'get-by-slug/' + slug, {params});
  }

  getProductByIds(ids: string[], select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }
    return this.httpClient.post<{
      data: Product[],
      count: number,
      success: boolean
    }>(API_URL + 'get-products-by-ids', {ids}, {params});
  }

  // /**
  //  * FIND PRODUCTS
  //  * findProductsByIds()
  // */
  // findProductsByIds(ids: string[]): Product[] {
  //   const selectedProducts: Product[] = [];
  //   ids.forEach(productId => {
  //     const product = this.allProducts.find(f => f._id === productId);
  //     if (product) {
  //       selectedProducts.push(product);
  //     }
  //   });
  //   return selectedProducts;
  // }

}
